import { JackpotDisplayType, Settings } from "../../Settings";
import { ITransition } from "./ITransition";
import { ITransitionParamsPIXIAPP } from "./ITransitionFactoryPIXIAPP";
import { RapidLinkResponsivePIXITransition } from "./RapidLinkResponsivePIXITransition";
import { TransitionAnimationSpineResponsive } from "./TransitionAnimationSpineResponsive";

export const jackpotTransitionsMap:Record<JackpotDisplayType, (params: ITransitionParamsPIXIAPP) => ITransition> = {
    [JackpotDisplayType.PreciousSpin]: function (params: ITransitionParamsPIXIAPP): ITransition {
        throw new Error("Function not implemented.");
    },
    [JackpotDisplayType.DiamondPot]: function (params: ITransitionParamsPIXIAPP): ITransition {
        throw new Error("Function not implemented.");
    },
    [JackpotDisplayType.DiamondPotOrtiz]: function (params: ITransitionParamsPIXIAPP): ITransition {
        throw new Error("Function not implemented.");
    },
    [JackpotDisplayType.DragonJackpot]: function (params: ITransitionParamsPIXIAPP): ITransition {
        throw new Error("Function not implemented.");
    },
    [JackpotDisplayType.DiamondPotStep]: function (params: ITransitionParamsPIXIAPP): ITransition {
        throw new Error("Function not implemented.");
    },
    [JackpotDisplayType.DiamondPotCaliente]: function (params: ITransitionParamsPIXIAPP): ITransition {
        throw new Error("Function not implemented.");
    },
    [JackpotDisplayType.DiamondPotPlayCity]: function (params: ITransitionParamsPIXIAPP): ITransition {
        throw new Error("Function not implemented.");
    },
    [JackpotDisplayType.PlayCityLink]: function (params: ITransitionParamsPIXIAPP): ITransition {
        throw new Error("Function not implemented.");
    },
    [JackpotDisplayType.PlayCityLinkResponsive]: function (params: ITransitionParamsPIXIAPP): ITransition {
        throw new Error("Function not implemented.");
    },
    [JackpotDisplayType.PlayCityLinkResponsivePIXI]: function (params: ITransitionParamsPIXIAPP): ITransition {
        throw new Error("Function not implemented.");
    },
    [JackpotDisplayType.JubileeLink]: function (params: ITransitionParamsPIXIAPP): ITransition {
        throw new Error("Function not implemented.");
    },
    [JackpotDisplayType.JubileeLinkResponsive]: function (params: ITransitionParamsPIXIAPP): ITransition {
        throw new Error("Function not implemented.");
    },
    [JackpotDisplayType.JubileeLinkResponsivePIXI]: function (params: ITransitionParamsPIXIAPP): ITransition {
        throw new Error("Function not implemented.");
    },
    [JackpotDisplayType.DiamondPotJubilee]: function (params: ITransitionParamsPIXIAPP): ITransition {
        throw new Error("Function not implemented.");
    },
    [JackpotDisplayType.PaytableJackpotDisplay]: function (params: ITransitionParamsPIXIAPP): ITransition {
        throw new Error("Function not implemented.");
    },
    [JackpotDisplayType.ViventoLink]: function (params: ITransitionParamsPIXIAPP): ITransition {
        throw new Error("Function not implemented.");
    },
    [JackpotDisplayType.RapidDiamondPot]: function (params: ITransitionParamsPIXIAPP): ITransition {
        throw new Error("Function not implemented.");
    },
    [JackpotDisplayType.RapidDiamondPot2]: function (params: ITransitionParamsPIXIAPP): ITransition {
        throw new Error("Function not implemented.");
    },
    [JackpotDisplayType.RapidDiamondPotStep]: function (params: ITransitionParamsPIXIAPP): ITransition {
        throw new Error("Function not implemented.");
    },
    [JackpotDisplayType.RapidDiamondPotFire]: function (params: ITransitionParamsPIXIAPP): ITransition {
        throw new Error("Function not implemented.");
    },
    [JackpotDisplayType.DiamondPotRappidFrames]: function (params: ITransitionParamsPIXIAPP): ITransition {
        throw new Error("Function not implemented.");
    },
    [JackpotDisplayType.DiamondPotStepRappidFrames]: function (params: ITransitionParamsPIXIAPP): ITransition {
        throw new Error("Function not implemented.");
    },
    [JackpotDisplayType.RapidDiamondPotStep2]: function (params: ITransitionParamsPIXIAPP): ITransition {
        throw new Error("Function not implemented.");
    },
    [JackpotDisplayType.RainbowGirls]: function (params: ITransitionParamsPIXIAPP): ITransition {
        throw new Error("Function not implemented.");
    },
    [JackpotDisplayType.DiamondPotStepShared]: function (params: ITransitionParamsPIXIAPP): ITransition {
        throw new Error("Function not implemented.");
    },
    [JackpotDisplayType.DiamondPotStepSinShared]: function (params: ITransitionParamsPIXIAPP): ITransition {
        throw new Error("Function not implemented.");
    },
    [JackpotDisplayType.DiamondPotResponsive]: function (params: ITransitionParamsPIXIAPP): ITransition {
        throw new Error("Function not implemented.");
    },
    [JackpotDisplayType.DiamondPotResponsivePIXI]: function (params: ITransitionParamsPIXIAPP): ITransition {
        throw new Error("Function not implemented.");
    },
    [JackpotDisplayType.DiamondPotResponsivePIXIHorizontal]: function (params: ITransitionParamsPIXIAPP): ITransition {
        throw new Error("Function not implemented.");
    },
    [JackpotDisplayType.DiamondPotStepRappidFramesSpine]: function (params: ITransitionParamsPIXIAPP): ITransition {
        throw new Error("Function not implemented.");
    },
    [JackpotDisplayType.DiamondPotRappidFramesSpine]: function (params: ITransitionParamsPIXIAPP): ITransition {
        throw new Error("Function not implemented.");
    },
    [JackpotDisplayType.DiamondPotStepSharedSpineV2]: function (params: ITransitionParamsPIXIAPP): ITransition {
        throw new Error("Function not implemented.");
    },
    [JackpotDisplayType.DiamondPotStepSinSharedSpineV2]: function (params: ITransitionParamsPIXIAPP): ITransition {
        throw new Error("Function not implemented.");
    },
    [JackpotDisplayType.DiamondPotPyramidShared]: function (params: ITransitionParamsPIXIAPP): ITransition {
        throw new Error("Function not implemented.");
    },
    [JackpotDisplayType.DiamondPotPyramidSinShared]: function (params: ITransitionParamsPIXIAPP): ITransition {
        throw new Error("Function not implemented.");
    },
    [JackpotDisplayType.DiamondPotPyramidJP4ShareJP3SinShared]: function (params: ITransitionParamsPIXIAPP): ITransition {
        throw new Error("Function not implemented.");
    },
    [JackpotDisplayType.DiamondPotPyramidShared2S]: function (params: ITransitionParamsPIXIAPP): ITransition {
        throw new Error("Function not implemented.");
    },
    [JackpotDisplayType.DiamondPotPyramidSinShared2S]: function (params: ITransitionParamsPIXIAPP): ITransition {
        throw new Error("Function not implemented.");
    },
    [JackpotDisplayType.DiamondPotPyramidJP4SharedJP3SinShared2S]: function (params: ITransitionParamsPIXIAPP): ITransition {
        throw new Error("Function not implemented.");
    },
    [JackpotDisplayType.DiamondPotPyramidSinSharedResponsive]: function (params: ITransitionParamsPIXIAPP): ITransition {
        throw new Error("Function not implemented.");
    },
    [JackpotDisplayType.JubileeLinkResponsivePIXIAPPHorizontal]: function (params: ITransitionParamsPIXIAPP): ITransition {
        throw new Error("Function not implemented.");
    },
    [JackpotDisplayType.JackpotDisplayPlayCityPIXIAPPHorizontal]: function (params: ITransitionParamsPIXIAPP): ITransition {
        throw new Error("Function not implemented.");
    },
    [JackpotDisplayType.JackpotDisplayRapidLinkPIXIAPPHorizontal]: function (params: ITransitionParamsPIXIAPP): ITransition {
        return new RapidLinkResponsivePIXITransition(params);
    }
}


export class JackpotTransitionSpineFactory extends TransitionAnimationSpineResponsive{
    CreateResponsiveTransition(params: ITransitionParamsPIXIAPP): ITransition {
        return jackpotTransitionsMap[Settings.JackpotDisplayType](params);
    }

}